import { gql } from "@apollo/client";

export const DeleteToastMessage = gql`
    mutation DeleteToastMessage($id: ID!) {
        deleteToastMessage(id: $id) {
            success
            message
        }
    }
`;
